import React, { Component } from "react";
import { PermDataSettingRounded } from "@mui/icons-material";
import DependencyHandler from "./Dependencies/DependencyHandler";
import DataHandler from "./DataHandling/DataHandler";
import RequestHandler from "./Request/RequestHandler";
import ThemesModul from "./Themes/ThemesModul";
import SaveChangesHandler from "./SaveChangesHandler";
import MessageHandler from "./MessageHandler";
import DataStore from "./stores/DataStore";
import AttributeStore from "./stores/AttributeStore";

/**
 * @class AttributeEdit
 * Attributedit Komponente die ingsgesamt eingebaut wird.
 * Ermöglicht Attributbearbeitung, Regelbedingte Attribute (mit errors, warnings, infos,..), und Attributabhängigkeiten untereinander
 * ...Hoffentlich zumindest
 * @component
 */
class AttributeEdit extends Component {
  constructor(params) {
    super(params);
    this.configSource = JSON.parse(JSON.stringify(this.props.config));
    this.targetConfig = JSON.parse(JSON.stringify(this.configSource));
    this.state = { currentConfig: this.targetConfig };
    const {
      config: {
        title = "",
        description = "",
        themesOptions = {},
        dataOptions = {},
        dependencyOptions = {},
        requestOptions = {},
        saveKey = "save",
        debug = false,
        editToolbar = false,
      },
      store, // mobxStore!
      requestStore,
      geo = {},
      editToolbarSettings, registerDataStore,
      geo: { LayerStore, map, mapStore, nls, controller, EditToolbar } = {},

    } = this.props;
    this.messageHandler = new MessageHandler(debug);
    this.store = store;
    this.requestHandler = new RequestHandler();
    const handler = {
      store: this.store,
      messageHandler: this.messageHandler,
      dataHandler: this.dataHandler,
      requestHandler: this.requestHandler,
      dependencyHandler: this.DependencyHandler,
      saveChangesHandler: this.saveChangesHandler,
    };
    // this.dataHandler = new DataHandler(dataOptions);
    DataStore.startUp(themesOptions, handler, requestStore, saveKey, map, registerDataStore);

    dataOptions.requestKeys = DataStore.attributeConfigs
      .map((conf) => conf.requestKey)
      .filter((o) => o !== undefined);

    this.dataHandler = new DataHandler(dataOptions);

    this.saveChangesHandler = new SaveChangesHandler(
      this.dataHandler,
      this.requestHandler,
      this.messageHandler,
      saveKey
    );

    this.dependencyHandler = new DependencyHandler(
      dependencyOptions,
      this.messageHandler
    );
    handler.dependencyHandler = this.dependencyHandler;
    handler.dataHandler = this.dataHandler;
    handler.saveChangesHandler = this.saveChangesHandler;
    DataStore.setUpReactionExternInfo(
      this.configSource,
      this.targetConfig,
      "$",
      this
    );
    DataStore.geo = geo;
    DataStore.editToolbarSettings = editToolbarSettings;
    if (editToolbar) {
      DataStore.controller = controller;
    }
    // DataStore.setHandler(handler);
  }

  componentDidMount() {
    this.dependencyHandler.refresh();
  }

  getEditToolbar() {
    if (DataStore.geo && DataStore.geo.EditToolbar) {
      return (
        // eslint-disable-next-line react/jsx-pascal-case
        <DataStore.geo.EditToolbar
          controller={DataStore.editController}
          nls={DataStore.geo.nls}
          map={DataStore.geo.map}
          view={DataStore.geo.view}
          layers={DataStore.geo.LayerStore.layers}
          noInfoBoxes={DataStore.geo.noInfoBoxes}
          selection={DataStore.geo.selection}
          LayerStore={DataStore.geo.LayerStore}
          noButtons
          changedIDs={[]}
          changedMap={{}}
        />
      );
    }
    return <div />;
  }

  getHeader() {
    const { title = "", description = "" } = this.props;
    return <div style={{ flexGrow: 0 }} />;
  }

  getInfo() {
    const { title = "", description = "" } = this.props;
    return <div>{description}</div>;
  }

  /**
   * Modul, welches die Anzeige eines der Themen zuständig ist.
   * Öffnet, je nach Typ, eines der verschiedenen Themenanzeigen.
   * @render
   * @param {object} props
   * @param {object} props.config
   * @param {string} [props.config.title=''] - Titel des Moduls
   * @param {string} [props.config.description=''] - Beschreibung des AttributEdits
   * @param {object} [props.config.themesOptions={}] - Konfiguration für die Themen
   * @param {string} [props.config.themesOptions.displayStyle="pages"]  - Anzeigeart ["pages", "accordeon", "tabs" ]
   * @param {Array<Object>} [props.config.themesOptions.themes=[]] - Array der Einzelthemen
   * @param {string} [props.config.themesOptions.themes.title = ""] - Titel des Themas
   * @param {string} [props.config.themesOptions.themes.description = ""] - Beschreibung des Themas
   * @param {object}[ props.config.themesOptions.themes.icon] - Icon, dass ggf. angezeigt wird
   * @param {Array<Object>} [props.config.themesOptions.themes.attributes =[]] - Array mit Attributen im Thema
   * @param {string} props.config.themesOptions.themes.attributes.id - ID des Attributes
   * @param {string} [props.config.themesOptions.themes.attributes.name] - Anzeigename des Attributes
   * @param {string} [props.config.themesOptions.themes.attributes.description ] - Beschreibung des Attributs
   * @param {string} [props.config.themesOptions.themes.attributes.tooltip] - Tooltip, welcher bei Hover über die Attributanzeige angezeigt werden soll
   * @param {string} props.config.themesOptions.themes.attributes.type - Typ des Attributs (z.b. "DropDown") ["dropDown", "textfield", "checkBox", "datePicker", "textArea", "multiChoice", "radioButtonGroup", "fileUpload", "numberTextField", "slider", "sliderGroup", "attributeCollection", "custom"]
   * @param {Component} [props.config.themesOptions.themes.attributes.CustomComponent] - CustomComponente, muss das Interface attribute implementieren
   * @param {*} [props.config.themesOptions.themes.attributes.value] - vorgegebener Wert
   * @param {boolean} [props.config.themesOptions.themes.attributes.visible = true] - gobt an, ob sichtbar
   * @param {boolean} [props.config.themesOptions.themes.attributes.readOnly = false] - Gibt an, ob das Attribut nur lesend betrachtet werden kann
   * @param {boolean} [props.config.themesOptions.themes.attributes.required = false] - Gibt an, ob das Attribut zwingend gefüllt werden muss.
   * @param {Array<Object>} [props.config.themesOptions.themes.attributes.rules=[]] - Array aus Regeln für das Attribut (mit den dazugehörigen Nachrichten)
   * @param {object} props.config.themesOptions.themes.attributes.rules.condition - condition, die angibt, wann die Regel verletzt ist.
   * @param {string} [props.config.themesOptions.themes.attributes.rules.ifViolatedType='error'] - Typ der Nachricht wenn Regel verletzt (error, warning, information, ...)
   * @param {string} [props.config.themesOptions.themes.attributes.rules.ifViolatedText = 'Regel verletzt'] - Text der Nachricht wenn Regel verletzt
   * @param {object} [props.config.themesOptions.themes.attributes.attributeOption={}] - Optionne für das spezielle Attribut (z.b. für das DropDown) =>genauer nachzuschauen
   * @param {object} [props.config.dataOptions={}] - Konfiguration für die Daten
   * @param {Array<Object>} [props.config.dataOptions.data=[]] Array an Daten - Daten können auch in der Config der einzelnen Felder angegeben werden, hier aber für z.b. Übergabe aus der Tabelle
   * @param {string} props.config.dataOptions.data.id id des zu einfügenden Datums
   * @param {*} props.config.dataOptions.data.value Wert der Daten
   * @param {object} props.config.dependencyOptions - Konfiguration für die Abhängigkeiten
   * @param {Array<Object>} [props.config.dependencyOptions.dependencies=[]] - Array der Abhängigkeiten
   * @param {object} props.config.dependencyOptions.dependencies.triggerCondition Bedingung
   * @param {string} [props.config.dependencyOptions.dependencies.triggerCondition.name=""]
   * @param {boolean} [props.config.dependencyOptions.dependencies.triggerCondition.defaultVal]
   * @param {Array<Object>} [props.config.dependencyOptions.dependencies.triggerCondition.and] Config für...
   * @param {Array<Object>} [props.config.dependencyOptions.dependencies.triggerCondition.or]
   * @param {object<Object>} [props.config.dependencyOptions.dependencies.triggerCondition.not]
   * @param {object<Object>} [props.config.dependencyOptions.dependencies.triggerCondition.atom]
   * @param {string} props.config.dependencyOptions.dependencies.triggerCondition.atom.attribute
   * @param {string} [props.config.dependencyOptions.dependencies.triggerCondition.atom.externAttribute] - falls etwas von einem wert des von extern Übergebenen Stores abhängen soll
   * @param {string} [props.config.dependencyOptions.dependencies.triggerCondition.atom.compareAttribute]
   * @param {string} [props.config.dependencyOptions.dependencies.triggerCondition.atom.externCompareAttribute]  - falls etwas von einem wert des von extern Übergebenen Stores abhängen soll
   * @param {boolean} [props.config.dependencyOptions.dependencies.triggerCondition.atom.lessThan] - evtl noch umzuprogrammieren: Bis jetzt steht der vergleichswert in CompareAttribtue, hier wäre praktischer
   * @param {boolean} [props.config.dependencyOptions.dependencies.triggerCondition.atom.biggerThan]- evtl noch umzuprogrammieren: Bis jetzt steht der vergleichswert in CompareAttribtue, hier wäre praktischer
   * @param {function} [props.config.dependencyOptions.dependencies.triggerCondition.atom.customCompareFunction]
   * @param {int} [props.config.dependencyOptions.dependencies.triggerCondition.atom.max]
   * @param {int} [props.config.dependencyOptions.dependencies.triggerCondition.atom.min]
   * @param {*} [props.config.dependencyOptions.dependencies.triggerCondition.atom.equals]
   * @param {boolean} [props.config.dependencyOptions.dependencies.triggerCondition.atom.filled]
   * @param {string} [props.config.dependencyOptions.dependencies.triggerCondition.atom.stringContains]
   * @param {function} [props.config.dependencyOptions.dependencies.triggerCondition.atom.customFunction]
   * @param {function} [props.config.dependencyOptions.dependencies.triggerCondition.atom.requestLoadingState] - gibt bei Auswertung true zurück, wenn der request des requestKeys des Attributes den hier angegebenen State beschreibt. Wird für BusyIndicatoren genutzt (BusyInd als Rule)
   * @param {string[]} [props.config.dependencyOptions.dependencies.triggerCondition.atom.multiAttributes] für Bedingungen die auf mehreren Attributen ausgewertet werden sollen
   * @param {string[]} [props.config.dependencyOptions.dependencies.triggerCondition.atom.multiExternAttributes] - falls etwas von mehreren Werten des von extern Übergebenen Stores abhängen soll
   * @param {function} [props.config.dependencyOptions.dependencies.triggerCondition.atom.customMultiAttributeFunction] Funktion auf mehreren Attributen (muss entweder direkt zu bool auswerten oder einen wert zurückgeben der mit customMultiAttributeFunction abgeglichen wird)
   * @param {*} [props.config.dependencyOptions.dependencies.triggerCondition.atom.customMultiAttributeFunctionValue]
   * @param {*} [props.config.dependencyOptions.dependencies.triggerCondition.atom.neutralVal] - Rückgabe, wenn Values noch nicht gesetzt
   * @param {boolean} [props.config.dependencyOptions.dependencies.triggerCondition.boolConstant]
   * @param {object} [props.config.dependencyOptions.dependencies.triggerCondition.serverCheck] - noch nicht Implementiert
   * @param {Array} props.config.dependencyOptions.dependencies.effects Effekte
   * @param {string[]} [props.config.dependencyOptions.dependencies.effects.display=[]] - AttributIDs, welche bei Eintreten der triggerCondition angezeigt werden sollen
   * @param {string[]} [props.config.dependencyOptions.dependencies.effects.hidden=[]] - AttributIDs, welche bei Eintreten der triggerCondition versteckt werden sollen
   * @param {string[]} [props.config.dependencyOptions.dependencies.effects.required=[]] - AttributIDs, welche bei Eintreten der triggerCondition required werden sollen
   * @param {string[]} [props.config.dependencyOptions.dependencies.effects.optional=[]] - AttributIDs, welche bei Eintreten der triggerCondition nicht required werden sollen
   * @param {string[]} [props.config.dependencyOptions.dependencies.effects.editable=[]] - AttributIDs, welche bei Eintreten der triggerCondition bearbeitbar werden sollen
   * @param {string[]} [props.config.dependencyOptions.dependencies.effects.readOnly=[]] - AttributIDs, welche bei Eintreten der triggerCondition readonly werden sollen
   * @param {Function} [props.config.dependencyOptions.dependencies.effects.customFunction]
   * @param {string[]} [props.config.dependencyOptions.dependencies.effects.customAttributes]
   * @param {object} props.config.requestOptions - Konfiguration für die Serverabfragen
   * @param {boolean} props.config.debug wenn true wird in die Konsole gelogged (Debug-Mode)
   * @param {boolean} props.config.debug.logprops.config wenn true, werden auch immer die props.config der Komponenten gelogged
   * @param {boolean} props.config.debug.logStates  wenn true, werden auch immer die States der Komponenten gelogged
   * @param {boolean} props.config.debug.showEmptyLogs  wenn true, werden auch leere Einträge geschrieben
   * @param {boolean} props.config.debug.showRender  wenn true, werden auch render- Einträge gelogged
   * @param {String} [props.config.saveKey="save"] Key für den Zugriff auf den requestStore, Speichern der Daten
   * @param {mobx} props.config.store Externer Store, falls bspw. Teile abhängig eines externen Stores
   * @param {mobx} props.config.requestStore Store für das Absetzen der Requests... wird in den Attributen tlw. gebraucht.
   * @param {object} [props.map ]
   */
  render() {
    const {
      currentConfig: {
        title = "",
        description = "",
        themesOptions = {},
        dataOptions = {},
        dependendyOptions = {},
        requestOptions = {},
        debug = false,
      },
    } = this.state;

    // const{editToolbarSettings}=this.props; 
    // if(editToolbarSettings){
    //   DataStore.editToolbarSettings= editToolbarSettings; 
    //   const {mapHandler, gridId, GridStore, keyAttribute } = editToolbarSettings; 
    //   if(mapHandler){
    //     GridStore.gridStores[gridId].setSelectedKeyVal(
    //       keyAttribute, DataStore.attributeValues[keyAttribute]    
    //     )
    //   }
    // }

    if (this.props.geo !== undefined) {
      DataStore.geo = this.props.geo;
    }
    this.messageHandler.logDebugFormatted(
      "AttributeEdit",
      "render",
      "",
      this.props,
      this.state
    );
    this.themesModul = (
      <ThemesModul
        themesOptions={themesOptions}
        debug={debug}
        editToolbar={this.getEditToolbar()}
      />
    );
    return (
      <div
        style={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          overflow: "auto",
        }}
      >
        {this.getHeader()}
        {this.themesModul}
      </div>
    );
  }
}
export default AttributeEdit;
